// pages/hr/wizard/steps/WelcomeStep.tsx
import React from 'react';
import { Box, Typography, Button } from '@mui/joy';
import { HandWaving as WavingHandOutlined } from '@phosphor-icons/react';
import type { WizardStepProps } from '../../../../types/hr';

export const WelcomeStep: React.FC<WizardStepProps> = ({
  sessionState,
  onNext,
}) => {
  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <WavingHandOutlined size={64} color="var(--joy-palette-primary-500)" style={{ marginBottom: 16 }} />
      <Typography level="h2" sx={{ mb: 2 }}>
        Welcome to {sessionState.organization_name}!
      </Typography>
      <Typography level="body-lg" color="neutral" sx={{ mb: 4, maxWidth: 500, mx: 'auto' }}>
        Hi {sessionState.team_member_name.split(' ')[0]}, we're excited to have you join our team. This onboarding
        process will help us get everything set up for your first day.
      </Typography>

      <Box sx={{ bgcolor: 'background.level1', borderRadius: 'lg', p: 3, mb: 4, maxWidth: 500, mx: 'auto' }}>
        <Typography level="title-md" sx={{ mb: 2 }}>
          What to expect:
        </Typography>
        <Box component="ul" sx={{ textAlign: 'left', pl: 2, m: 0 }}>
          <Typography component="li" level="body-md" sx={{ mb: 1 }}>
            Personal information collection
          </Typography>
          <Typography component="li" level="body-md" sx={{ mb: 1 }}>
            Employment details confirmation
          </Typography>
          <Typography component="li" level="body-md" sx={{ mb: 1 }}>
            Tax forms and documentation
          </Typography>
          <Typography component="li" level="body-md" sx={{ mb: 1 }}>
            Required document signing
          </Typography>
          <Typography component="li" level="body-md">
            Final review and submission
          </Typography>
        </Box>
      </Box>

      <Typography level="body-sm" color="neutral" sx={{ mb: 3 }}>
        This process typically takes about 10-15 minutes. You can save your progress at any time and return later.
      </Typography>

      <Button size="lg" onClick={onNext}>
        Let's Get Started
      </Button>
    </Box>
  );
};

export default WelcomeStep;
